import React from "react";
import { AddBetaChannelUserModalTemplate } from "themes/administration/app-release/components";

function AddBetaChannelUser(props) {
    return <AddBetaChannelUserModalTemplate {...props} />;
}

export default AddBetaChannelUser;
